import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'

export default {
  props: {
    isGalleryModal: {
      type: Boolean,
      default: false,
    },
    sharedItems: {
      type: Array,
      default: null,
    }
  },
  computed: {
    listSelected() {
      return this.bcSelectedStore.listFullySelected.filter((el) => el.type !== 'color-row' && el.type !== 'table-row')
    },
    ...mapStores(useBcSelectedStore)
  },
  methods: {
    selectAllGalleryModal() {
      if (this.isGalleryModal && this.listSelected.length === 0) {
        this.sharedItems.forEach(item => {
          this.bcSelectedStore.select(item)
        })
      }
    }
  }
}